import React, { useState } from "react";
import {
  ButtonDone,
  ColContent,
  ContentInsight,
  ContentAnswerInsight,
  ContentCommentsInsight,
  ContentFormInsight,
  ContentProfile,
  ContentUpdateButton,
  GeneralContainerInsight,
  ImgProfile,
  RowForm,
} from "./MyInsightDetailComponent.styled";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Box, Tab, Tabs } from "@mui/material";
import TabPanel from "../TabPanel/TabPanel";
import { TextField, IconButton } from "@material-ui/core";
import { theme as themeConfig } from "../../themes/themes";
import imageProfileComments from "../../assets/svg/img-profile.svg";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import CommentsCases from "../CommentsCases/CommentsCases";

const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

const MyInsightDetailComponent = ({
  comments,
  policyQuestionAnswers,
  idCase,
  caseStatus,
  handleCreateComment,
  handleUpdateComment,
  isEditComment,
  commentData,
  setCommentData,
  handleEditComment,
  handleDeleteComment,
  handleCancelUpdateComment,
  handleSendChanges,
  permissions,
}) => {
  const [valueTab, setValueTab] = useState(0);

  const handleChangeTabValue = (event, newValue) => {
    setValueTab(newValue);
  };

  let handleChangeInput = (event, item) => {
    if (item && event.target.value) {
      setCommentData({
        idCase: idCase,
        comment: event.target.value,
      });
    }
  };

  let handleChangeInputEdit = (event, item) => {
    if (item && event.target.value) {
      setCommentData({
        idCase: item.idCase,
        idCaseComment: item.idCaseComment,
        comment: event.target.value,
      });
    }
  };

  let renderForm = () => {
    return (
      <RowForm>
        <ColContent>
          <ContentProfile>
            <ImgProfile src={imageProfileComments} alt="" />
          </ContentProfile>
        </ColContent>
        <ColContent>
          <TextField
            id="comment-description"
            variant="standard"
            placeholder="Type your comment"
            onChange={(e) => handleChangeInput(e, idCase)}
          />
        </ColContent>
        <ColContent>
          <IconButton onClick={() => handleCreateComment(commentData)}>
            <ArrowCircleUpIcon />
          </IconButton>
        </ColContent>
      </RowForm>
    );
  };

  let renderComments = () => {
    return (
      comments?.length > 0 &&
      comments.map((item, index) => {
        return (
          <CommentsCases
            key={index}
            item={item}
            handleUpdateComment={handleUpdateComment}
            handleChangeInputEdit={handleChangeInputEdit}
            isEditComment={isEditComment}
            handleEditComment={handleEditComment}
            handleDeleteComment={handleDeleteComment}
            handleCancelUpdateComment={handleCancelUpdateComment}
            commentData={commentData}
          />
        );
      })
    );
  };

  return (
    <GeneralContainerInsight>
      <ContentFormInsight>
        {policyQuestionAnswers?.map((item, index) => (
          <ContentAnswerInsight key={index}>
            <p>
              {++index + " " + item.idQuestionFormNavigation.questionTitle}{" "}
            </p>
            <p>{item.answer}</p>
          </ContentAnswerInsight>
        ))}
      </ContentFormInsight>
      <ContentCommentsInsight>
        <ContentInsight>
          <p style={{ fontWeight: "600" }}>Status</p>
          <p>
            <CheckCircleOutlineIcon /> {caseStatus}
          </p>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              indicatorColor="secondary"
              value={valueTab}
              onChange={handleChangeTabValue}
              aria-label="comments-tabs"
            >
              <Tab
                style={{
                  textTransform: "capitalize",
                  color: themeConfig.text.primary,
                  width: "13em",
                }}
                label="Comments"
                {...a11yProps(0)}
              />
            </Tabs>
          </Box>
          <TabPanel value={valueTab} index={0}>
            <p>
              {permissions
                .map((item) => item.actionName)
                .indexOf("AddComment") !== -1 && renderForm()}
            </p>
            <p>{renderComments()}</p>
            <ContentUpdateButton>
              <ButtonDone
                disabled={commentData ? false : true}
                onClick={() => handleSendChanges(commentData)}
              >
                Send Changes
              </ButtonDone>
            </ContentUpdateButton>
          </TabPanel>
        </ContentInsight>
      </ContentCommentsInsight>
    </GeneralContainerInsight>
  );
};

export default MyInsightDetailComponent;
